module.exports = __webpack_public_path__ + "img/664e02a.png";